module.exports = __webpack_public_path__ + "img/x.8a635a4a.svg";